import React from 'react';
import { Grid, InputLabel, MenuItem, Select, TextField } from '@material-ui/core';
import FormSection from '../../../../components/atom/FormSection';
import {
    activityAutocomplete,
    onlyClientAutocomplete,
    onlyVendorAutocomplete
} from '../../../../autocomplete';
import AutocompleteSelect from '../../../../components/atom/AutocompleteSelect';

const ACTIVITY_FIELD_TYPES = [
    {
        type: 'include',
        name: 'Include these after the vendor limitation'
    },
    {
        type: 'exclude',
        name: 'Exclude these after the vendor limitation'
    }
];
const LIMITATION_FIELD_TYPES = [
    {
        type: 'include',
        name: 'Include only these, exclude everything else'
    },
    {
        type: 'exclude',
        name: 'Exclude only these, include everything else'
    }
];

export default function ClientEditLimitationSettings({ values, setFieldValue }) {
    if (!values.is_client && !values.is_vendor) {
        return null;
    }
    return (
        <>
            {values.is_client && (
                <FormSection title="Filter vendors / activities on the site">
                    <Grid item xs={12}>
                        Vendors available on the site
                        <h5>Here you can configure vendor visibility on the site.</h5>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel>Type of limitation</InputLabel>
                        <Select
                            fullWidth
                            value={values.vendor_limitation_type}
                            onChange={event => {
                                setFieldValue('vendor_limitation_type', event.target.value);
                            }}
                        >
                            {LIMITATION_FIELD_TYPES.map(fieldType => (
                                <MenuItem key={fieldType.name} value={fieldType.type}>
                                    {fieldType.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </Grid>
                    <Grid item xs={8}>
                        <AutocompleteSelect
                            initCall={onlyVendorAutocomplete.init}
                            autocompleteCall={onlyVendorAutocomplete.search}
                            value={values.vendor_limitations || []}
                            setValue={newValue => {
                                setFieldValue('vendor_limitations', newValue);
                            }}
                            multiple
                        >
                            <TextField label="List of vendors" />
                        </AutocompleteSelect>
                    </Grid>
                    <Grid item xs={12}>
                        Activities available on the site
                        <h5>
                            Here you can configure activity visibility on the site, these filters
                            are applied after the Vendor limitation.
                        </h5>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel>Type of limitation</InputLabel>
                        <Select
                            value={values.activity_limitation_type}
                            onChange={event => {
                                setFieldValue('activity_limitation_type', event.target.value);
                            }}
                        >
                            {ACTIVITY_FIELD_TYPES.map(fieldType => (
                                <MenuItem key={fieldType.name} value={fieldType.type}>
                                    {fieldType.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </Grid>
                    <Grid item xs={8}>
                        <AutocompleteSelect
                            initCall={activityAutocomplete.init}
                            autocompleteCall={activityAutocomplete.search}
                            value={values.activity_limitations || []}
                            setValue={newValue => {
                                setFieldValue('activity_limitations', newValue);
                            }}
                            multiple
                        >
                            <TextField label="List of activities" />
                        </AutocompleteSelect>
                    </Grid>
                </FormSection>
            )}
            {values.is_vendor && (
                <FormSection title="Selling limitation">
                    <Grid item xs={12}>
                        Limit sites that can sell your Activities
                        <h5>
                            As a vendor you can exclude sites, where you don't want to sell your
                            activities
                        </h5>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel>Type of limitation</InputLabel>
                        <Select
                            value={values.client_limitation_type}
                            onChange={event => {
                                setFieldValue('client_limitation_type', event.target.value);
                            }}
                        >
                            {LIMITATION_FIELD_TYPES.map(fieldType => (
                                <MenuItem key={fieldType.name} value={fieldType.type}>
                                    {fieldType.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </Grid>
                    <Grid item xs={8}>
                        <AutocompleteSelect
                            initCall={onlyClientAutocomplete.init}
                            autocompleteCall={onlyClientAutocomplete.search}
                            value={values.client_limitations || []}
                            setValue={newValue => {
                                setFieldValue('client_limitations', newValue);
                            }}
                            multiple
                        >
                            <TextField label="List of clients" />
                        </AutocompleteSelect>
                    </Grid>
                </FormSection>
            )}
        </>
    );
}
